import React from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Card,
  CardContent,
  LinearProgress,
  Chip,
  Paper,
  Tooltip,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from "@mui/icons-material/Info";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";

const AgentProfile = ({ agentAnalytics, overview }) => {
  console.log(overview, "-0-");

  const deadAirArray = agentAnalytics?.AgentCommunicationMetrics?.DeadAir || [];
  const maxDeadAir = Math.max(
    ...deadAirArray.map((d) => Number(d?.Duration) || 0),
    0
  );

  const deadAirColor =
    maxDeadAir < 5
      ? colorTheme("palette", "positive").value
      : colorTheme("palette", "negative").value;

  const isDeadAirPositive = maxDeadAir < 5;

  const politenessScore =
    agentAnalytics?.AgentCommunicationMetrics?.PolitenessAndClarity || 0;

  let politenessColor = colorTheme("palette", "negative").value; // default red

  if (politenessScore >= 90)
    politenessColor = colorTheme("palette", "positive").value;
  else if (politenessScore >= 80 && politenessScore < 90)
    politenessColor = "#FFC107"; // Yellow color

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Left Panel */}
        <Grid item xs={12} md={4} sx={{ display: "flex" }}>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ position: "relative" }}>
              <Box
                component="img"
                src="https://plus.unsplash.com/premium_vector-1721131162397-943dc390c744?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww"
                alt="Customer"
                sx={{
                  width: "100%",
                  height: 200,
                  objectFit: "contain",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  p: 2,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                }}
              >
                {/* <Typography
                  variant="h5"
                  component="div"
                  sx={{ color: "white", fontWeight: 500 }}
                >
                  {agentAnalytics?.AgentProfile?.AgentName}
                </Typography> */}
              </Box>
            </Box>
            <CardContent>
              <Box mb={2}>
                <ProfileItem
                  label="Agent Name"
                  value={agentAnalytics?.AgentProfile?.AgentName}
                />
                <ProfileItem
                  label="Greeting"
                  value={agentAnalytics?.ParameterScorecard?.Greeting?.Score}
                />
                <ProfileItem
                  label="Empathy Rating"
                  value={agentAnalytics?.ParameterScorecard?.Empathy?.Score}
                />
                <ProfileItem
                  label="Tone And Manner"
                  value={
                    agentAnalytics?.ParameterScorecard?.ToneAndManner?.Score
                  }
                />
                {/* <ProfileItem
                  label="Resolution Rate"
                  value={
                    agentAnalytics?.ParameterScorecard?.ProblemResolution?.Score
                  }
                /> */}
                <ProfileItem
                  label="Call Closing"
                  value={agentAnalytics?.ParameterScorecard?.CallClosing?.Score}
                />
                <ProfileItem
                  label="Product Knowledge"
                  value={
                    agentAnalytics?.ParameterScorecard?.ProductKnowledge?.Score
                  }
                />
              </Box>
              <Box>
                <Typography fontSize={14} fontWeight="600" mb={1}>
                  Agent Performance
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <Box sx={{ width: "85%" }}>
                    <LinearProgress
                      variant="determinate"
                      value={
                        agentAnalytics?.ParameterScorecard
                          ?.OverallParameterScore
                      }
                      sx={{
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: "#e0e0e0",
                        "& .MuiLinearProgress-bar": {
                          // backgroundColor: "#7367F0",
                          backgroundColor: colorTheme("palette", "primary")
                            .value,
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "10%" }}>
                    <Typography
                      // color="#7367F0"
                      color={colorTheme("palette", "primary").value}
                      fontSize={12}
                      mt={1}
                      fontWeight={900}
                      sx={{}}
                    >
                      {
                        agentAnalytics?.ParameterScorecard
                          ?.OverallParameterScore
                      }{" "}
                      %
                    </Typography>
                  </Box>
                </Box>

                <Typography fontSize={11} color="gray">
                  {agentAnalytics?.AgentScorecard?.Commentary}
                </Typography>
              </Box>
            </CardContent>
          </Paper>
        </Grid>

        {/* Right Panel */}
        <Grid item xs={12} md={8} sx={{ display: "flex" }}>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 2,
              p: 3,
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            <Typography
              variant="body1"
              fontWeight="525"
              mb={3}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              🗣️ &nbsp;Agent Communication Metrics
              <Tooltip
                title="Gives the basic quality checks and KPIs."
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Typography>
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* Greeting Delivered */}
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      backgroundColor:
                        agentAnalytics?.AgentCommunicationMetrics
                          ?.GreetingDelivered == "Yes"
                          ? colorTheme("palette", "positive").value
                          : colorTheme("palette", "negative").value,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 900,
                    }}
                  >
                    {agentAnalytics?.AgentCommunicationMetrics
                      ?.GreetingDelivered == "Yes" ? (
                      <CheckIcon
                        sx={{ color: "white", fontWeight: 900, fontSize: 20 }}
                      />
                    ) : (
                      <CloseIcon sx={{ color: "white", fontSize: 20 }} />
                    )}
                  </Box>
                  {/* <ShieldCheck color="green" strokeWidth={2.35} /> */}
                  <Box>
                    <Typography fontSize={14}>Greeting Delivered</Typography>
                    <Box display="flex" gap={1} alignItems="center">
                      <Typography
                        sx={{
                          color:
                            agentAnalytics?.AgentCommunicationMetrics
                              ?.GreetingDelivered == "Yes"
                              ? colorTheme("palette", "positive").value
                              : colorTheme("palette", "negative").value,
                        }}
                        fontWeight={700}
                        fontSize={18}
                      >
                        {
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.GreetingDelivered
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>

              {/* Verification Completed */}
              {/* <Grid item xs={12} sm={6} md={4}>
                <Card
                
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      backgroundColor:
                        agentAnalytics?.AgentCommunicationMetrics
                          ?.VerificationCompleted == "Yes"
                          ?  colorTheme('palette', 'positive').value
                              : colorTheme('palette', 'negative').value,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {agentAnalytics?.AgentCommunicationMetrics
                      ?.VerificationCompleted == "Yes" ? (
                      <CheckIcon
                        sx={{ color: "white", fontWeight: 900, fontSize: 20 }}
                      />
                    ) : (
                      <CloseIcon sx={{ color: "white", fontSize: 20 }} />
                    )}
                  </Box>
                 
                  <Box>
                    <Typography fontSize={14}>Verification</Typography>
                    <Box display="flex" gap={1} alignItems="center">
                      <Typography
                        sx={{
                          color:
                            agentAnalytics?.AgentCommunicationMetrics
                              ?colorTheme('palette', 'positive').value
                              : colorTheme('palette', 'negative').value,
                        }}
                        fontWeight={700}
                        fontSize={18}
                      >
                        {
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.VerificationCompleted
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid> */}

              {/* //sentiment score */}
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      backgroundColor:
                        (overview?.SentimentScores?.Agent?.score ?? 0) >= 60
                          ? colorTheme("palette", "positive").value
                          : colorTheme("palette", "negative").value,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography fontWeight={700} fontSize={14} color="#fff">
                      {overview?.SentimentScores?.Agent?.score ?? 0}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography fontSize={14}>Sentiment Score</Typography>
                    <Typography
                      fontWeight={700}
                      fontSize={18}
                      color={
                        (overview?.SentimentScores?.Agent?.score ?? 0) >= 60
                          ? colorTheme("palette", "positive").value
                          : colorTheme("palette", "negative").value
                      }
                    >
                      {overview?.SentimentScores?.Agent?.score ?? 0} / 100
                    </Typography>
                  </Box>
                </Card>
              </Grid>

              {/* Empathy Used */}
              {/* <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <StarIcon
                    sx={{ color: "orange", fontSize: 35, stroke: 2.25 }}
                    color="orange"
                    strokeWidth={2.25}
                  />
                  {/* <Star color="orange" strokeWidth={2.25} /> */}
              {/* <Box>
                    <Typography fontSize={14}>Empathy Used</Typography>
                    <Box color="orange" fontWeight={900} fontSize={20}>
                      {agentAnalytics?.AgentCommunicationMetrics?.EmpathyScore
                        ? `${agentAnalytics?.AgentCommunicationMetrics?.EmpathyScore}/5`
                        : "NA"}
                    </Box>
                  </Box>
                </Card>
              </Grid> */}
              <Grid item xs={12} sm={6} md={4}>
                {(() => {
                  const empathyScore =
                    Number(
                      agentAnalytics?.AgentCommunicationMetrics?.EmpathyScore
                    ) || 0;

                  // Color logic
                  const empathyColor =
                    empathyScore < 3
                      ? colorTheme("palette", "negative").value // red
                      : colorTheme("palette", "positive").value; // green

                  return (
                    <Card
                      sx={{
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        border: "1px solid #f7f8f9",
                        height: 80,
                        borderRadius: 3,
                      }}
                    >
                      <StarIcon
                        sx={{
                          color: empathyColor,
                          fontSize: 35,
                        }}
                      />

                      <Box>
                        <Typography fontSize={14}>Empathy Used</Typography>

                        <Box
                          sx={{
                            color: empathyColor,
                            fontWeight: 900,
                            fontSize: 20,
                          }}
                        >
                          {agentAnalytics?.AgentCommunicationMetrics
                            ?.EmpathyScore
                            ? `${empathyScore}/5`
                            : "NA"}
                        </Box>
                      </Box>
                    </Card>
                  );
                })()}
              </Grid>

              {/* Interruptions */}
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    padding: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      backgroundColor:
                        agentAnalytics?.AgentCommunicationMetrics
                          ?.Interruptions == "Yes"
                          ? colorTheme("palette", "negative").value
                          : colorTheme("palette", "positive").value,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {agentAnalytics?.AgentCommunicationMetrics?.Interruptions ==
                    "Yes" ? (
                      <CloseIcon sx={{ color: "white", fontSize: 20 }} />
                    ) : (
                      <CheckIcon
                        sx={{ color: "white", fontWeight: 900, fontSize: 20 }}
                      />
                    )}
                  </Box>
                  {/* <CircleX color="#ff0000" strokeWidth={2.35} /> */}
                  <Box>
                    <Typography fontSize={14}>Interruptions</Typography>
                    <Box display="flex" gap={1} alignItems="center">
                      <Typography
                        color={
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.Interruptions == "Yes"
                            ? "error"
                            : colorTheme("palette", "positive").value
                        }
                        fontWeight={700}
                        fontSize={18}
                      >
                        {
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.Interruptions
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>

              {/* Dead Air */}
              {/* <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #f7f8f9",
                    height: 80,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      // backgroundColor: "#EA5455",
                      backgroundColor: colorTheme("palette", "negative").value,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PlayArrowIcon sx={{ color: "white", fontSize: 22 }} />
                  </Box>
                  <Box>
                    <Typography fontSize={14}>Dead Air</Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      {agentAnalytics?.AgentCommunicationMetrics?.DeadAir?.map(
                        (e, i) => (
                          <Box>
                            <Typography
                              fontWeight={700}
                              color="error"
                              fontSize={18}
                            >
                              {e?.Duration}{" "}
                            </Typography>
                            <Typography fontSize={11} color="gray">
                              {e?.Timestamp}{" "}
                            </Typography>
                          </Box>
                        )
                      )}
                    </Box>
                  </Box>
                </Card>
              </Grid> */}
              {/* Dead Air */}
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    height: 80,
                  }}
                >
                  <Box
                    sx={{
                      width: 33,
                      height: 33,
                      borderRadius: "50%",
                      backgroundColor: deadAirColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isDeadAirPositive ? (
                      <CheckIcon sx={{ color: "white", fontSize: 20 }} />
                    ) : (
                      <PlayArrowIcon sx={{ color: "white", fontSize: 22 }} />
                    )}
                  </Box>

                  <Box>
                    <Typography fontSize={14}>Dead Air</Typography>

                    <Box display="flex" alignItems="center" gap={1}>
                      {deadAirArray.length > 0 ? (
                        deadAirArray.map((e, i) => (
                          <Box key={i}>
                            <Typography
                              fontWeight={700}
                              fontSize={18}
                              color={
                                deadAirColor
                                // Number(e?.Duration) < 5
                                //   ? "success.main"
                                //   : "error.main"
                              }
                            >
                              {e?.Duration}
                            </Typography>
                            <Typography fontSize={11} color="gray">
                              {e?.Timestamp}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Typography
                          color={colorTheme("palette", "positive").value}
                        >
                          No Dead Air
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Card>
              </Grid>

              {/* Politeness & Clarity */}
              {/* <Grid item xs={12} sm={6} md={4}>
                <Card sx={{ p: 2, height: 80, borderRadius: 3 }}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Box
                      sx={{
                        width: 33,
                        height: 33,
                        borderRadius: "50%",
                        backgroundColor: colorTheme("palette", "primary").value,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <InfoIcon sx={{ color: "white", fontSize: 18 }} />
                    </Box>
                    <Box flex={1}>
                      <Typography fontSize={14}>
                        Politeness & Clarity
                      </Typography>
                      <LinearProgress
                        variant="determinate"
                        value={
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.PolitenessAndClarity
                        }
                        sx={{
                          height: 8,
                          borderRadius: 5,
                          mt: 1,
                          // color: "#7367F0",
                          color: colorTheme("palette", "primary").value,
                          backgroundColor: "#e0e0e0",
                          "& .MuiLinearProgress-bar": {
                            // backgroundColor: "#7367F0",
                            backgroundColor: colorTheme("palette", "primary")
                              .value,
                          },
                        }}
                      />
                      <Typography
                        fontSize={13}
                        mt={1}
                        sx={{ color: colorTheme("palette", "primary").value }}
                        // color="#7367F0"
                        color={colorTheme("palette", "primary").value}
                        fontWeight="600"
                      >
                        {
                          agentAnalytics?.AgentCommunicationMetrics
                            ?.PolitenessAndClarity
                        }{" "}
                        %
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid> */}
              {/* Politeness & Clarity */}
              <Grid item xs={12} sm={6} md={4}>
                <Card sx={{ p: 2, height: 80, borderRadius: 3 }}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Box
                      sx={{
                        width: 33,
                        height: 33,
                        borderRadius: "50%",
                        backgroundColor: politenessColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {politenessScore > 90 ? (
                        <CheckIcon sx={{ color: "white", fontSize: 20 }} />
                      ) : politenessScore >= 80 ? (
                        <InfoIcon sx={{ color: "white", fontSize: 20 }} />
                      ) : (
                        <CloseIcon sx={{ color: "white", fontSize: 20 }} />
                      )}
                    </Box>

                    <Box flex={1}>
                      <Typography fontSize={14}>
                        Politeness & Clarity
                      </Typography>

                      <LinearProgress
                        variant="determinate"
                        value={politenessScore}
                        sx={{
                          height: 8,
                          borderRadius: 5,
                          mt: 1,
                          backgroundColor: "#e0e0e0",
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: politenessColor,
                          },
                        }}
                      />

                      <Typography
                        fontSize={13}
                        mt={1}
                        fontWeight={600}
                        sx={{ color: politenessColor }}
                      >
                        {politenessScore} %
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

const ProfileItem = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mb={1}>
    <Typography fontSize={13} color="gray">
      {label}
    </Typography>
    <Typography fontSize={13} fontWeight={600}>
      {value}
    </Typography>
  </Box>
);

const MetricCard = ({ icon, color, label, value }) => {
  const iconBg = {
    green: colorTheme("palette", "positive").value,
    red: colorTheme("palette", "negative").value,
    indigo: colorTheme("palette", "primary").value,
  }[color];

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        variant="outlined"
        sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}
      >
        <Avatar sx={{ bgcolor: iconBg }}>{icon}</Avatar>
        <Box>
          <Typography fontSize={14}>{label}</Typography>
          <Box
            display="inline-block"
            px={1}
            border="2px solid black"
            bgcolor={iconBg}
            color="#fff"
            fontWeight="bold"
            fontSize={16}
            borderRadius={1}
            mt={0.5}
          >
            {value}
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

export default AgentProfile;
